// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"72c2422e","513":"cbae8f14","545":"24096400"}[chunkId] + ".chunk.js";
};